import {connect} from '@modifi/redux'

import {selectFileByIdent} from '@modifi/plugin-documents'
import SubmitProgressDialog, {SubmitProgressDialogProps} from './SubmitProgressDialog'
import {
  selectSubmitErrorMessage,
  selectSubmitHasError,
  selectSubmitPending,
  aSubmit,
  aReset,
  selectSubmitErrorObject,
} from '../../store'

const mapStateToProps = (
  state: Record<string, any>,
  ownProps: {params: {fileIdent?: string}}
): Pick<
  SubmitProgressDialogProps,
  'fileUploadProgress' | 'submitPending' | 'submitHasError' | 'submitErrorMessage' | 'errorObject'
> => ({
  fileUploadProgress: ownProps?.params?.fileIdent
    ? selectFileByIdent(state)(ownProps.params.fileIdent)?.progress
    : undefined,
  submitPending: selectSubmitPending(state),
  submitHasError: selectSubmitHasError(state),
  submitErrorMessage: selectSubmitErrorMessage(state),
  errorObject: selectSubmitErrorObject(state),
})

const mapDispatchToProps = {
  submitShipment: aSubmit,
  clearShipment: aReset,
}

export const DIALOG_NAME = 'SUBMIT_PROGRESS_DIALOG'

export default connect(mapStateToProps, mapDispatchToProps)(SubmitProgressDialog)
